import React from "react"; 
import { PricingModel } from "../enums";
import { DescriptionCell, LabelCell } from "../styles";
import { CustomLabel, FlexContainer, InfoIcon, SingleSelect } from "@mindmemobile/mm-shared-global";

type Props = {
  hasError: boolean;
  onChange(option: string): void;
  selectedValue: keyof typeof PricingModel | string;
};
export default class PricingOptionRow extends React.Component<Props> {
  get options() {
    return Object.keys(PricingModel).map((key: string) => {
      return {
        value: key,
        label: PricingModel[key as keyof typeof PricingModel],
      };
    });
  }
  render() {
    return (
      <FlexContainer className="label-description-row billing-starts-row">
        <LabelCell>
          <CustomLabel>Pricing Option </CustomLabel>
          <InfoIcon />
        </LabelCell>
        <DescriptionCell>
          <SingleSelect
            hasError={this.props.hasError}
            selectedKey={this.props.selectedValue}
            nameKeys={["label"]}
            valueKeys={["value"]}
            options={[this.options]}
            onChange={(option) => this.props.onChange(option.value)}
            className="dpdn-no-separator"
          />
        </DescriptionCell>
      </FlexContainer>
    );
  }
}
